class CheckboxMinRequired {
  constructor(element) {
    try {
      this.checkBoxArr = element;
      this.isMinChecked = this.isChecked.bind(this);
      
    } catch (error) {
      console.log(error);
    }
  }

  isChecked(isMinRequired, array) {
    this.checkBoxArr.forEach(item =>{
      array = item.querySelectorAll("input[type='checkbox']");
      isMinRequired = [...array].some(checkboxes => checkboxes.checked);
      if (!isMinRequired){
          item.querySelector('.sd-fieldset').classList.add('sd-input--error');
          item.querySelector('.sd-tooltip').classList.add('sd-tooltip--error');
      }else{
          if(item.querySelector('.sd-tooltip').classList.contains('sd-tooltip--error')){
              item.querySelector('.sd-fieldset').classList.remove('sd-input--error');
              item.querySelector('.sd-tooltip').classList.remove('sd-tooltip--error');
          }
      }
    })
    return isMinRequired;
  }
}

export default CheckboxMinRequired;
